import { render, staticRenderFns } from "./TermEdit.vue?vue&type=template&id=60908dd8&"
import script from "./TermEdit.vue?vue&type=script&lang=js&"
export * from "./TermEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports